import { useTranslation } from 'react-i18next'
import { useInstallationFromParams } from '@/features/installations/hooks/useInstallationFromParams'

export function DashboardHome() {
  const { t } = useTranslation('common')
  const installation = useInstallationFromParams()

  return (
    <div className="flex flex-1 flex-col gap-4 p-6">
      <h1 className="text-2xl font-semibold tracking-tight">
        {t('common:nav.dashboard')}
      </h1>
      <p className="text-muted-foreground">
        {installation?.name
          ? t('operatorsShell.dashboardPlaceholderWithInstallation', {
              name: installation.name,
            })
          : t('operatorsShell.dashboardPlaceholder')}
      </p>
    </div>
  )
}
